import React from "react";
import { Grid } from "@mui/material";
import { MainContainer, AmountsBlock, Amounts, AmountBlock, AmountTitle } from "./styles";
import AuditDocument from "../../AuditNotesActions/AuditDocument/AuditDocument";
import { TravelExpenseRef } from "../../../../../../../../../models/travel-expenses";
import { EmployeeRef } from "../../../../../../../../../models/employees";
import AuditNotes from "../../AuditNotesActions/AuditNotes/AuditNotes";
import ReceiptStatus from "../../ReceiptComponents/ReceiptStatus/ReceiptStatus";
import { DocumentDTO } from "../../../../../../../../../models/documents";
import { TravelExpenseAuditNotesDTO } from "../../../../../../../../../models/travel-expense-audit-notes";
import { useTranslation } from "react-i18next";

interface Props {
  travelExpense: TravelExpenseRef;
  employee: EmployeeRef;
  handleNotifyParent: (document: DocumentDTO | null) => void;
  defaultTravelExpense: TravelExpenseRef;
  disabledAuditActions: boolean;
  updateLastAuditNote: (auditNote: TravelExpenseAuditNotesDTO) => void;
  hideAuditNotes: boolean;
  isManagedByLink?: boolean;
}

const InfoAndNotesSection = ({
  travelExpense,
  employee,
  handleNotifyParent,
  defaultTravelExpense,
  disabledAuditActions,
  updateLastAuditNote,
  hideAuditNotes,
  isManagedByLink,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "components.add_edit_travel_expense";

  return (
    <MainContainer>
      <ReceiptStatus auditAccepted={travelExpense.auditAccepted} />

      <AmountsBlock>
        <Grid flex={1}>
          <AmountTitle>{`${t(`${tRP}.fields.accepted_amount`)}`}:</AmountTitle>
        </Grid>
        <AmountBlock flex={1}>
          <Amounts
            aceeptedAmount
            title={`${t(`${tRP}.fields.accepted_amount`)}: ${travelExpense.acceptedAmount.toLocaleCustom()} ${
              travelExpense.currency?.code ?? ""
            }`}
          >{`${travelExpense.acceptedAmount.toLocaleCustom()} ${travelExpense.currency?.code ?? ""}`}</Amounts>
        </AmountBlock>
      </AmountsBlock>

      <AmountsBlock>
        <Grid flex={1}>
          <AmountTitle>{`${t(`${tRP}.fields.difference`)}`}:</AmountTitle>
        </Grid>
        <AmountBlock flex={1}>
          <Amounts
            title={`${t(`${tRP}.fields.difference`)}: ${travelExpense.difference.toLocaleCustom()} ${
              travelExpense.currency?.code ?? ""
            }`}
          >{`${travelExpense.difference.toLocaleCustom()} ${travelExpense.currency?.code ?? ""}`}</Amounts>
        </AmountBlock>
      </AmountsBlock>

      <>
        {!!defaultTravelExpense.auditNotes.length && !hideAuditNotes && (
          <>
            {/* <AuditDocument
              travelExpense={travelExpense}
              document={travelExpense.auditDocument}
              employee={employee}
              handleNotifyParent={handleNotifyParent}
              readOnly={disabledAuditActions}
              customTitleStyle={{
                fontWeight: "bold",
                color: "inherit",
              }}
            /> */}

            <AuditNotes
              employee={employee}
              travelExpense={defaultTravelExpense}
              legalEntity={employee?.legalEntity ?? defaultTravelExpense?.legalEntity}
              readOnly={disabledAuditActions}
              updateLastAuditNote={updateLastAuditNote}
              textInsteadChipTitle
              isManagedByLink={isManagedByLink}
            />
          </>
        )}
      </>
    </MainContainer>
  );
};

export default InfoAndNotesSection;
